// extracted by mini-css-extract-plugin
export default {"shareButton":"ProfilePage_shareButton__F87yO","shareIcon":"ProfilePage_shareIcon__3hEVm"};